import './FormJump.css'
import Dropdown from '../../../../../components/UI/DropDown/DropDown';
import { useTreeStateContext } from '/src/features/editor/contexts/TreeContext';
import TitleBlock from '../TitleBlock/TitleBlock';
import { useForm } from "react-hook-form";
import editorAction from '../../../actions/editorAction';
import { useState } from 'react';
import { BlockJumpDefault } from '../../../data/constant/blocks/BlockJumpDefault';
import binarySearchString from '../../../utils/binarySearchString'
import TextArea from '/src/components/UI/TextField/TextArea';
import CheckBox from '/src/components/UI/CheckBox/CheckBox';
import { useBotStateContext } from '../../../contexts/BotContext';

function FormJump({ id }) {

    const { variables } = useBotStateContext();

    const cleanInput = (val) => val.replace(/\[/g,'').replace(/\]/g,'');

    const isVariableFind = (val) => {
        if (!val) return false;
        let hasBrackets = val.startsWith("[") && val.endsWith("]");
        val = cleanInput(val); 
        return variables.filter( variable => variable.name == val.toLowerCase()).length > 0 && hasBrackets;
    };

    const { blocks } = useTreeStateContext();
    const indexBlock = binarySearchString(blocks, id, 'object_id');
    const block = blocks[indexBlock] ? blocks[indexBlock] : BlockJumpDefault
    const { data } = block;
    const name = block.name;
    const scenarios = blocks.filter(block => block.type && block.type.name == 'scenario').map(block => { return { id: block.id, value: block.object_id, text: block.name } })
    scenarios.sort((a, b) => a.text.localeCompare(b.text)) // sort in ascending order
    const { updateBlockDataJump } = editorAction();
    const [title, setTitle] = useState(name);
    
    const subProps = {};
    let scenario = null;
    if (data.jump_id) {
        scenario = scenarios.filter(scenario => scenario.id == data.jump_id.id).pop()
    }

    scenario ? subProps.defaultChoice = scenario.value : subProps.placeholder = "Select a scenario";

    const { register, handleSubmit, watch, formState: { errors }, formState, getValues, setValue } = useForm({
        mode: "onBlur",
        defaultValues: { scenario: subProps.defaultChoice || null, is_constant: data.is_constant, variable_value : data.variable_value}
    });

    const setDropdown = (name, value) => {
        setValue(name, value);
        onSubmit(getValues());
    }

    const onSubmit = (form) => {
        const scenario = blocks.filter(block => block.object_id == form.scenario).pop();
        //const titleBlock = /^Jump to /.test(name) ? "Jump to " + scenario.name : name;  
        const titleBlock = scenario? scenario.name : "Jump to ..."; // pour retirer le jump to quand il y a deja une valeur
        setTitle(titleBlock);
        updateBlockDataJump(id, titleBlock, scenario, data.block_id, form.is_constant, form.variable_value);
        return;
    }
    const onBlur = (e) => {
        onSubmit(getValues())
    }
    return (
        <>
            <TitleBlock title="Jump" titleInput="Jump's name" name={title} id={id} key={title} />
            <form className='area-edit' onSubmit={handleSubmit(onSubmit)}>
                <div className="jump_constant_redirection_container">
                    <label className="input_title">Constant redirection</label>
                    <CheckBox name="Resume" onChange={() => {setValue("is_constant", (!getValues("is_constant"))),onBlur()}} checked={getValues("is_constant")} />
                </div>
                <label className="input_title">Jump to Scenario</label>

                {
                    watch("is_constant") == true ?
                        <Dropdown {...register('scenario')} setValue={setDropdown} choices={scenarios} width="calc(100%)" {...subProps}  />
                        :
                        <>
                            <div className='area-edit'>
                                <TextArea className={"input resize-area jump_variable_value_input " + (isVariableFind(getValues("variable_value")) ? "variables_found_jump_content" : "")}{...register('variable_value')} onBlur={onBlur} placeholder="Please, enter a block id or a variable which contains a block id"></TextArea>
                            </div>
                        </>
                }

            </form>
        </>
    )
}

export default FormJump;